module.exports = __webpack_public_path__ + "img/screencast.258c2a7c.png";